/**
 * @description: 寄存结转报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-jcj-report">
        <div class="jcj-list">
            <el-form :inline="true" size="small" :model="jcj_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="jcj_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="jcj_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="jcj_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="jcj_list_form.shop_id" filterable clearable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="jcj_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="jcj_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="jcjQuery">查询</el-button>
                    <el-button @click="jcjExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="jcj_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="start_stock" label="期初数量"></el-table-column>
                <el-table-column prop="deposit" label="寄存数量"></el-table-column>
                <el-table-column prop="take" label="取酒数量"></el-table-column>
                <el-table-column prop="confiscate" label="充公数量"></el-table-column>
                <el-table-column prop="recover_confiscate" label="取消充公数量"></el-table-column>
                <el-table-column prop="end_stock" label="期末数量"></el-table-column>
                <el-table-column prop="buying_price" label="成本价"></el-table-column>
                <el-table-column prop="buying_price_total" label="期末成本总额"></el-table-column>
                <el-table-column label="操作" v-if="canCheckDetail">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="setPageParams(scope.row)">期末详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">寄存总量:</label>
                    <div class="list-total">{{jcj_deposit_sum}}</div>
                    <label class="list-label-4">取酒总量:</label>
                    <div class="list-total">{{jcj_take_sum}}</div>
                    <label class="list-label-4">期末总量:</label>
                    <div class="list-total">{{jcj_end_stock_sum}}</div>
                    <label class="list-label-6">期末成本总额:</label>
                    <div class="list-total">{{jcj_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="jcj_list_page"
                    :total="jcj_list_total"
                    @current-change="getJcjList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="jcj_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="jcj_export_sign" v-model="jcj_export_all" @change="jcjExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="jcj_export_ids" @change="jcjExportChange">
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="start_stock">期初数量</el-checkbox>
                    <el-checkbox label="deposit">寄存数量</el-checkbox>
                    <el-checkbox label="take">取酒数量</el-checkbox>
                    <el-checkbox label="confiscate">充公数量</el-checkbox>
                    <el-checkbox label="recover_confiscate">取消充公数量</el-checkbox>
                    <el-checkbox label="end_stock">期末数量</el-checkbox>
                    <el-checkbox label="buying_price">成本价</el-checkbox>
                    <el-checkbox label="buying_price_total">期末成本总额</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="jcj_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="jcj_export_type" label="2">pdf文件</el-radio>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                goods_type_list: [],
                jcj_list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    goods_type: '',
                    goods_name: '',
				},
				jcj_list: [],
				jcj_list_page: 1,
                jcj_list_total: 0,
                jcj_export_sign: false,
				jcj_export_all: false,
                jcj_export_ids: [],
                jcj_export_list: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'start_stock', 'deposit', 'take', 'confiscate', 'recover_confiscate', 'end_stock', 'buying_price', 'buying_price_total'],
                jcj_export_type: '1',
                jcj_deposit_sum: '',
                jcj_take_sum: '',
                jcj_end_stock_sum: '',
                jcj_buying_price_total: '',
                report_system_index_menu: {}, // 报表系统
                book_export_log_list: [], // 历史预约
            }
        },
        computed: {
            menunew() {
                return JSON.parse(this.$store.state.menunew)
            },
            canCheckDetail() {
                // 将日期字符串转换为 Date 对象
                const dateObject = new Date(this.jcj_list_form.end_time);

                // 获取今天的日期
                const today = new Date();

                // 判断日期是否是上个营业日
                const isYesterday = dateObject.toDateString() === today.toDateString();
                return isYesterday
            }
        },
        mounted: function() {
            // 日期
            this.jcj_list_form.start_time = moment().subtract(1, 'day').format('YYYY-MM-DD 08:00');
            this.jcj_list_form.end_time = moment().format('YYYY-MM-DD 08:00');
            this.innitDate();
            this.getPageMenu();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.jcj_list_form.shop_id = this.shop_list[0].id;
                this.getGoodsType();
                this.getJcjList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.jcj_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.jcj_list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.jcj_list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 跳转菜单
            getPageMenu: function() {
                this.menunew.forEach(i => {
                    if(i.id == '544') { // 报表
                        i.submenu.forEach(j => {
                            if(j.id == '568') { // 酒水寄存
                                j.submenu.forEach(k => {
                                    if(k.id == '1273') { // 寄存结存明细报表（报表系统）
                                        this.report_system_index_menu = k
                                    }
                                })
                            }
                        })
                    }
                })
            },
            // 跳转参数
            setPageParams(row) {
                const obj = {
                    name: 'report_system_index',
                    params: {
                        business_day: this.jcj_list_form.end_time,
                        goods_name: row.goods_name,
                        shop_id:  this.jcj_list_form.shop_id,
                        to: this.report_system_index_menu.redirect_url
                    }
                }
                this.$emit("pageLink", this.report_system_index_menu, obj)
            },


            getJcjList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FinanceReport2/getDepositGoods', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.jcj_list_form.start_time,
                            "end_time": _this.jcj_list_form.end_time,
							"shop_id": _this.jcj_list_form.shop_id,
							"goods_type": _this.jcj_list_form.goods_type,
							"goods_name": _this.jcj_list_form.goods_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.jcj_list_total = Number(res.data.response.data.total);
							_this.jcj_deposit_sum = res.data.response.data.deposit_sum;
                            _this.jcj_take_sum = res.data.response.data.take_sum;
                            _this.jcj_end_stock_sum = res.data.response.data.end_stock_sum
                            _this.jcj_buying_price_total = res.data.response.data.buying_price_total
						}
						_this.jcj_list = res.data.response.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			jcjQuery() {
				this.getJcjList(1);
            },
            // 导出
            jcjExportAll(val) {
				this.jcj_export_ids = val ? this.jcj_export_list : [];
				this.jcj_export_sign = false;
			},
			jcjExportChange(val) {
				const len = val.length;
				this.jcj_export_all = len === this.jcj_export_list.length;
				this.jcj_export_sign = len > 0 && len < this.jcj_export_list.length;
			},
            jcjExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport2/depositGoodsExport"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.jcj_export_ids = res.data.response.result.export_fields;
                            _this.jcj_export_type = res.data.response.result.export_type;
                        } else {
                            _this.jcj_export_ids = _this.jcj_export_list;
                            _this.jcj_export_type = '1';
                        }
                        _this.jcjExportChange(_this.jcj_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.jcj_list_export)
                }, function() {
                    _this.checkExport();
                });
            },

            // 检查导出状态
            checkExport() {
                let _this = this
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'depositGoods',
                        "param": {
                            "page": _this.jcj_list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.jcj_list_form.start_time,
                            "end_time": _this.jcj_list_form.end_time,
                            "shop_id": _this.jcj_list_form.shop_id,
                            "goods_type": _this.jcj_list_form.goods_type,
                            "goods_name": _this.jcj_list_form.goods_name,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.jcjExport();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this
                let export_fields = JSON.stringify(_this.jcj_export_ids);

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'depositGoods',
                        "param": {
                            "page": _this.jcj_list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.jcj_list_form.start_time,
                            "end_time": _this.jcj_list_form.end_time,
                            "shop_id": _this.jcj_list_form.shop_id,
                            "goods_type": _this.jcj_list_form.goods_type,
                            "goods_name": _this.jcj_list_form.goods_name,
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            jcjExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/depositGoodsExport" +
                    "?start_time=" + this.jcj_list_form.start_time +
                    "&end_time=" + this.jcj_list_form.end_time +
                    "&shop_id=" + this.jcj_list_form.shop_id +
                    "&goods_type=" + this.jcj_list_form.goods_type +
                    "&goods_name=" + this.jcj_list_form.goods_name +
                    "&export_fields=" + JSON.stringify(this.jcj_export_ids) +
                    "&export_type=" + this.jcj_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>